<template>
    <div v-if="currentGuideline.assessment_methods">
        <div class="columns is-mobile">
            <div class="column">
                <p class="title has-text-left">Edit Validation Plan</p>
            </div>
        </div>

        <!-- General Info -->
        <div class="tile is-ancestor">
            <div class="tile is-12 is-horizontal is-parent">
                <div class="tile is-child box"> 
                    <div class="column">
                        <b-field class="has-text-left" label="Validation plan name">
                            <b-input name="validation_plan_template_name" v-model="currentValidationPlanTemplate.name" placeholder="Template name"></b-input>
                        </b-field>
                    </div>

                    <div class="column has-text-left">
                        <p class="is-size-6 has-text-weight-bold">Guidelines</p>
                        {{guideLineSelectionComputed.name}}
                    </div>

                    <div class="column">
                        <div class="field has-text-left">
                            <label class="label">Comment</label>
                            <div class="control">
                                <textarea class="textarea" v-model="currentValidationPlanTemplate.comment"  placeholder="Textarea"></textarea>
                            </div>
                        </div>
                    </div>             
                </div>          
            </div>
        </div>   
        <!-- /General Info -->

        <div class="tile is-ancestor">
            <div class="tile has-text-left is-12 is-vertical is-parent">    
                <!-- Validation Parameters Start -->
                <div v-for="valParam in validationParameterSet" :key="valParam" >
                    <a class="button accordionButton is-large is-fullwidth" style="margin-top:20px" :id="valParam" v-on:click="accordionAction(valParam)">
                        <span>
                            {{valParam}}
                        </span>
                        <span class="icon is-small is-pulled-right">
                            <i class="fas fa-caret-down"></i>
                        </span>
                    </a>

                    <div class="tile is-ancestor contentOfAccordion">
                        <div class="tile is-parent">
                            <div class="tile is-child box">
                                <div class="content has-text-left">
                                    <!-- Heading of Validation Parameter -->
                                    <div class="columns is-mobile">
                                        <div class="column">
                                            <strong>Method of Assessment</strong>
                                        </div>
                                    </div>
                                    <!-- /Heading of Validation Parameter -->

                                    <!-- content of Validation Parameter -->
                                    <div class="box has-background-white-ter" v-for="assesmentMethod in guideLineSelection.assessment_methods" :key="assesmentMethod.id"v-if="assesmentMethod.validation_parameter_display == valParam">
                                        <div>
                                            <b-checkbox v-model="assessmentMethodcheckboxGroup"
                                            :native-value="assesmentMethod.id">
                                                {{assesmentMethod.name}}
                                            </b-checkbox>
                                            <div class="column">
                                                <p class="has-text-weight-bold" style="margin-bottom:0px; paading-bottom:0px;">Criteria:</p>
                                                <!-- criteria and value -->
                                                <div v-for="criteria in assesmentMethod.criteria" :key="criteria.id">
                                                    <div class="column">
                                                        <b-checkbox v-model="criteriaCheckboxGroup"
                                                        :native-value="criteria.id">
                                                            <span class="">{{criteria.name}}</span> :
                                                            <b-field class="has-text-left" >
                                                                <b-input name="method_name" v-model="criteria.value" placeholder="Criterion Value"></b-input>
                                                            </b-field>
                                                        </b-checkbox>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="assesmentMethod.metadatas && assesmentMethod.metadatas.length">
                                              <p class="is-size-7 has-text-weight-bold">Parameters</p>
                                              <metadata-component :metadata-list="assesmentMethod.metadatas" :editable="true"></metadata-component>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /content of Validation Parameter -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Validation Parameters end --> 

                <!-- Action buttons -->
                <div class="column" style="margin-top:50px">
                    <span class="is-pulled-right">
                        <a class="button is-large is-primary" @click="submitEditedTemplate">
                            <span>Update</span>
                        </a>
                        <span style="margin-left:20px"></span>
                        <a class="button is-large" @click="back">
                            <span>Back</span>
                        </a>
                    </span>
                    <a class="button is-warning is-pulled-left is-large" @click="submitArchivedTemplate">
                        <span>Archive</span>
                    </a>
                </div>
                <!-- Action buttons End -->
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex'
import MetadataParser from "@/valchrom/MetadataParser";
import PageTitleDisplay from "@/components/features/displayElements/PageTitleDisplay";
import MetadataComponent from "@/valchrom/common/metadata/MetadataComponent";
export default {
    name: "EditValidationPlanTemplateComponent",
    props: ["currentValidationPlanTemplate", "currentGuideline", "assesmentMethods", "guidelines", "validationParameters"],
    components: {MetadataComponent},
    computed: {
        ...mapGetters ([
            'base_url'
        ]),
        guideLineSelectionComputed: function(){   
            if(this.guideLineSelection== ''){
                this.guideLineSelection=this.guidelines.find( guideline => guideline.id == this.currentGuideline.id)
                 this.guideLineSelection.assessment_methods.forEach(am =>
                 {
                   MetadataParser.setAmMetadata(this.currentValidationPlanTemplate, am)
                 })

                //assessmentmethods
                this.guideLineSelectionChange()
            }
            return this.guideLineSelection
        },
        validationParameterSet: function(){   
            var valParamSet = new Set()    
            this.currentGuideline.assessment_methods.forEach(function(method) {                
                valParamSet.add(method.validation_parameter_display)
            })
            var arr = Array.from(valParamSet)
            arr.sort((a, b) => {return this.validationParameters.indexOf(a) - this.validationParameters.indexOf(b)})
            return arr
        },
    },

    data: function() {
        return {
            isEmpty: false,
            isLoading: false,
            isOpenActive: true,
            isOpenArchived: false,
            assMethcheckboxGroup: [],
            guideLineSelection: '',
            assessmentMethodcheckboxGroup: [],
            criteriaCheckboxGroup: [],
        }
    },
    methods : {     
        submitEditedTemplate: function(){
            var mainThis = this
            
            mainThis.currentValidationPlanTemplate.assessment_methods=[]
            this.assessmentMethodcheckboxGroup.forEach(function(assessmentMethod){
                mainThis.currentValidationPlanTemplate.assessment_methods.push(assessmentMethod)
            })            
            
            mainThis.currentValidationPlanTemplate.criteria = []
            this.guideLineSelection.assessment_methods.forEach(function(assessmentMethod){
                assessmentMethod.criteria.forEach(function(criteria){
                    mainThis.criteriaCheckboxGroup.forEach(function(criteriaId){
                        if(criteriaId == criteria.id){
                            mainThis.currentValidationPlanTemplate.criteria.push(criteria)
                        } 
                    })            
                })
            })
            MetadataParser.setMetadataJsonsFromAms(this.currentValidationPlanTemplate, this.guideLineSelection.assessment_methods);
            console.log("params",this.currentValidationPlanTemplate, this.guideLineSelection.assessment_methods)
            console.log('currentValidationPlanTemplate: ', this.currentValidationPlanTemplate)
            this.$emit("submitEditedTemplate", this.currentValidationPlanTemplate)
        },
        back: function() {
            this.$emit("back", this.currentValidationPlanTemplate);
        },
        submitArchivedTemplate: function(){
            this.$emit("submitArchivedTemplate", this.currentValidationPlanTemplate)
        },
        guideLineSelectionChange: function(){
            console.log('guideLineSelectionChange: ', this.guideLineSelection)
            var mainThis = this
            this.modifyCriteiaObjects()

            mainThis.assessmentMethodcheckboxGroup = []
            mainThis.criteriaCheckboxGroup = []
            this.currentValidationPlanTemplate.assessment_methods.forEach(function(method){
                mainThis.assessmentMethodcheckboxGroup.push(method)
            })

            this.currentValidationPlanTemplate.criteria.forEach(function(criteria){                
                mainThis.criteriaCheckboxGroup.push(criteria.id)
            })
        },
        modifyCriteiaObjects: function(){
            var mainThis = this 
            mainThis.guideLineSelection.assessment_methods.forEach(function(assesmentMethod){
                if(assesmentMethod.criteria.length>0){
                    assesmentMethod.criteria.forEach(function(criterion){
                        var criterionTemp = mainThis.currentValidationPlanTemplate.criteria.find( criteria => criteria.id == criterion.id )
                        if (criterionTemp){
                            criterion.value = criterionTemp.value
                        }
                    })
                }
            })            
        },


        accordionAction: function(id) {
            var accordionButton = document.getElementById(id)
            var contentOfAccordion = document.getElementById(id).nextSibling
            // console.log("x.style.display", x) is-primary 
            if (contentOfAccordion.style.display == "block") {
                contentOfAccordion.style.display = "none"
                accordionButton.classList.remove("is-primary");
            } else if (contentOfAccordion.style.display == "none") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            } else if(contentOfAccordion.style.display == "") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            }

            // accordionButton class
            var otherAccordions = Array.from(document.getElementsByClassName("accordionButton"))
            // console.log("ohters...", otherAccordions)    
            otherAccordions.forEach(function(otherAccordionButton){
                if(accordionButton != otherAccordionButton){
                    var content = otherAccordionButton.nextSibling
                    content.style.display = "none"
                    otherAccordionButton.classList.remove("is-primary");
                }
                
            })

        }  
    }
}
</script>


<style scoped>
.contentOfAccordion{
    display: none;
}
</style>
